"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const MaterialTextField_1 = __importDefault(require("../inputs/MaterialTextField"));
const MaterialSwitch_1 = __importDefault(require("../inputs/MaterialSwitch"));
const FormControls_1 = __importDefault(require("../controls/FormControls"));
exports.default = (0, mobx_react_1.observer)(({ form }) => (react_1.default.createElement("form", null,
    react_1.default.createElement("h2", { className: "light-red" }, "Form Register"),
    react_1.default.createElement("h4", null, "Material UI"),
    react_1.default.createElement(MaterialTextField_1.default, { field: form.$('username') }),
    react_1.default.createElement(MaterialTextField_1.default, { field: form.$('email') }),
    react_1.default.createElement(MaterialTextField_1.default, { field: form.$('emailConfirm') }),
    react_1.default.createElement(MaterialTextField_1.default, { field: form.$('password'), type: "password" }),
    react_1.default.createElement(MaterialTextField_1.default, { field: form.$('devSkills') }),
    react_1.default.createElement(MaterialSwitch_1.default, { field: form.$('terms') }),
    react_1.default.createElement(FormControls_1.default, { form: form }))));
